/* eslint-disable no-unused-vars */
const state = {
  loading: false,
  user: null,
}

const getters = {
  isAuthenticated: (state) => !!state.user || localStorage.getItem('TMSHELPER_USER'),
}

const mutations = {
  SET_LOADING(state, flag) {
    state.loading = flag
  },
  SET_USER(state, user) {
    state.user = user
  },
}

const wait = async (t, val) => new Promise((resolve) => setTimeout(resolve, t, val))

const actions = {
  async login({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)

      wait(500).then(() => {
        const uuid = crypto.randomUUID()
        const validUsername = process.env.VUE_APP_ADMIN_USERNAME || 'admin'
        const validPassword = process.env.VUE_APP_ADMIN_PASSWORD || 'admin'

        if (username === validUsername && password === validPassword) {
          localStorage.setItem('TMSHELPER_USER_TOKEN', uuid)
          localStorage.setItem('TMSHELPER_USER', { username, is_admin: true, token: uuid })
          commit('SET_USER', { username, is_admin: true, token: uuid })
          resolve()
        } else {
          reject(new Error('Credenziali non corrette.'))
        }
        commit('SET_LOADING', false)
      })
    })
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      localStorage.removeItem('TMSHELPER_USER_TOKEN')
      localStorage.removeItem('TMSHELPER_USER')
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
